import { AbstractControl, ValidationErrors } from '@angular/forms';
import { isEmpty } from 'lodash';
import { DateTime } from 'luxon';

export function dateGreaterThanOrEqualToTodayValidator(
  FormControl: AbstractControl
): ValidationErrors | null {
  const { value, errors, statusChanges } = FormControl;

  const formControlDate = DateTime.fromJSDate(value);
  const currentDate = DateTime.fromJSDate(new Date());

  let foundErrors = null;

  if (
    !formControlDate.isValid ||
    formControlDate.valueOf() < currentDate.valueOf()
  ) {
    foundErrors = Object.assign(errors || {}, {
      dateLessThanCurrentDate: true
    });
  } else if (errors) {
    delete errors['dateLessThanCurrentDate'];
    // It seems as though each validator should return null or a specific error. Don't need
    // to merge errors together.
    // foundErrors = isEmpty(errors) ? null : errors;
    foundErrors = null;
  }

  // Does not seem like setting an error is required.
  // if (statusChanges) {
  //   FormControl.setErrors(foundErrors);
  // }

  return foundErrors;
}
